import { createFileRoute } from "@tanstack/react-router";
import { SeoContentPage } from "@/components/SeoContentPage";
import { tennisHusselApp } from "@/pages/seo-content";

const title = "App voor tennis hussel – hussel indelingen systeem & software | De Hussel App";
const description = "Tennis hussel app die hussel indelingen automatisch maakt. Hussel indelingen software voor tennis- en padelclubs: eerlijk, snel en zonder vrijwilligers.";

export const Route = createFileRoute("/tennis-hussel-app")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://dehusselapp.nl/tennis-hussel-app" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://dehusselapp.nl/tennis-hussel-app" }],
  }),
  component: () => <SeoContentPage data={tennisHusselApp} />,
});
